"use strict";
var thumbs = document.getElementById("thumbs");
var largeImg = document.getElementById("largeImg");
thumbs.addEventListener("click", function(newevent) {
    newevent.preventDefault();
    // Знаходимо найближчий елемент <a> від того, на що клікнули
    // .closest() шукає вгору по DOM — працює і якщо клікнули на <img>, і на <a>
    var link = newevent.target.closest("a");
    // Якщо клік був поза посиланням — ігноруємо
    if (!link) return;
    // Беремо URL великого зображення з атрибута href посилання
    largeImg.src = link.href;
    // Оновлюємо alt великого зображення з атрибута title посилання
    largeImg.alt = link.title;
});

//# sourceMappingURL=index.77b3f6e9.js.map
